// src/oura/components/unsentReplies.ts
//
// Replies typed in an item's thread and not sent, per item and side, for as
// long as the page lives. The thread sits in a drawer, and Escape, Close or
// "Later" unmount it with the drawer; what was typed, and the file chosen,
// are there again when it reopens. In memory only: a chosen File cannot be
// stored, and a reply is not worth keeping past a reload.

import type { Audience } from "@service/aeo/clientReview";

export interface UnsentReply {
    body: string;
    file: File | null;
}

const unsent = new Map<string, UnsentReply>();
const keyOf = (me: Audience, itemId: string) => `${me}:${itemId}`;

export function readUnsentReply(me: Audience, itemId: string): UnsentReply | undefined {
    return unsent.get(keyOf(me, itemId));
}

/** Keep what is typed; an empty reply is forgotten. */
export function keepUnsentReply(me: Audience, itemId: string, reply: UnsentReply): void {
    if (reply.body || reply.file) unsent.set(keyOf(me, itemId), reply);
    else unsent.delete(keyOf(me, itemId));
}

/** Whether this side has a reply on this item typed and not sent. */
export function hasUnsentReply(me: Audience, itemId: string): boolean {
    return unsent.has(keyOf(me, itemId));
}
